module.exports = __webpack_public_path__ + "static/media/khimki-favicon.87e1f426.ico";